import { render, staticRenderFns } from "./WorkItem.vue?vue&type=template&id=1eaba79e&scoped=true&"
import script from "./WorkItem.vue?vue&type=script&lang=js&"
export * from "./WorkItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkItem.vue?vue&type=style&index=0&id=1eaba79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaba79e",
  null
  
)

export default component.exports